import * as Sentry from '@sentry/react'

import { resolveDomain, RestClient } from '@affiliate-cabinet/rest'

import { languagesMap } from '../languages'
import { I18nDictionaryLanguageKeysType } from '../languages/types'

const client = new RestClient('/api/translations', {}, resolveDomain(!window.__APP_CONFIG__.domains.sb.isSandbox(window.location.host)), {
  mode: 'cors',
  referrerPolicy: 'no-referrer',
})

export const dictionaryLoad = async (langKey: I18nDictionaryLanguageKeysType, projectAlias: string, version?: string) => {
  if (!projectAlias) {
    throw new Error('You need to pass project alias')
  }

  const parameters: { version?: string } = {}

  if (version) {
    parameters.version = version
  }

  try {
    return await client.get<Record<string, string>>(`${projectAlias}-${languagesMap[langKey]}.json`, parameters)
  } catch (error) {
    Sentry.captureException(error, (scope) => {
      scope.setExtra('message', "Can't get dictionary from translation service")

      return scope
    })

    return {}
  }
}
